@if (bannerPopupService.isOpen) {
  <div class="modal-banner">
    <div class="modal-banner-content" [ngClass]="{'__is-clickable': bannerPopupService.onClickCallback !== null}">
      <div class="close-modal" (click)="closeModal()">
        <i class="fas fa-times"></i>
      </div>
      @if (bannerPopupService.imageURL) {
        <img
          [src]="bannerPopupService.imageURL"
          [alt]="alt"
          (click)="onClick()"
          >
      }
    </div>
  </div>
}
